import './ChartTooltip.css'

import PropTypes from 'prop-types'
import React from 'react'
import { hexToRGBA } from 'utils'

import { DEFAULT_COLOR, DEFAULT_OPACITY } from './constants'

const ChartTooltip = ({ data, label: index, payload, tooltipHeaderFormatter, tooltipLabelFormatter }) => (
  <div className="chart-tooltip">
    <div className="chart-tooltip_label">{data[index] && tooltipHeaderFormatter(data[index].tooltipHeader)}</div>
    <div className="chart-tooltip_list">
      {payload &&
        payload.map(item => (
          <div
            className="chart-tooltip_list-item"
            key={item.dataKey}
            style={{
              color:
                item.dataKey === 'current'
                  ? item.color || item.payload.color || DEFAULT_COLOR
                  : hexToRGBA(item.color || item.payload.color || DEFAULT_COLOR, DEFAULT_OPACITY),
            }}
          >
            {tooltipLabelFormatter(data[index][item.dataKey], item.dataKey)}
          </div>
        ))}
    </div>
  </div>
)

ChartTooltip.propTypes = {
  data: PropTypes.array.isRequired,
  label: PropTypes.number,
  payload: PropTypes.array,
  tooltipHeaderFormatter: PropTypes.func.isRequired,
  tooltipLabelFormatter: PropTypes.func.isRequired,
}

export default ChartTooltip
